import { Carousel } from './Carousel';
import { Grid } from './Grid';
import { List } from './List';
import { Masonry } from './Masonry';
import { Slider } from './Slider';

export const variations = {
  grid: Grid,
  masonry: Masonry,
  list: List,
  carousel: Carousel,
  slider: Slider
};
